import * as React from "react";
import BaseComponent from "src/engine/ui/BaseComponent";
import { getCookie, getBaseUrl } from "../../util";
import QRCode from "qrcode.react";
import "./index.scss";

interface IProps {
    myCode: string;
    onClose: () => void;
}

interface IState {}

// 邀请下载图片
class InvitePicTureModal extends BaseComponent<IProps, IState> {
    render() {
        const { myCode, onClose } = this.props;
        const code = myCode || "";
        const shareUrl = `${getBaseUrl()}?code=${code}`;
        console.log("shareUrl", shareUrl);
        return (
            <div className="invite-picture-modal">
                <div className="invite-picture-content">
                    <div className="btn-close" onClick={onClose}></div>
                    {shareUrl ? (
                        <div className="pic-code">
                            <QRCode
                                id="qrCode"
                                value={shareUrl}
                                size={200} // 二维码的大小
                                fgColor="#000000" // 二维码的颜色
                                // imageSettings={{
                                //     // 二维码中间的logo图片
                                //     src: "https://zengwu.com.cn/images/avatar.png",
                                //     height: 100,
                                //     width: 100,
                                //     excavate: true, // 中间图片所在的位置是否镂空
                                // }}
                            />
                        </div>
                    ) : null}
                </div>
            </div>
        );
    }
}

export default InvitePicTureModal;
